export function signInErrorMessage(body: string): string {
  try {
    const { code } = JSON.parse(body);
    if (code === "SCREENING_UNAVAILABLE") {
      return "Wallet verification is temporarily unavailable. Please try signing in again shortly.";
    }
    if (code === "SANCTIONS_MATCH") {
      return "This wallet cannot sign in because it has a sanctions-list match.";
    }
  } catch {
    // Provider bodies may be HTML or contain internal diagnostics.
  }
  return "We couldn't complete sign-in. Please try again.";
}
